import React from 'react';
import propTypes from 'prop-types';
import ConstituentType from '@/constants/ConstituentType';
import useConstituent from '@/lib/hooks/swr/useConstituent';
import translate from '@/lib/intl/translate';
import FileUploader from '@/modules/FileUploader';
import { ConstituentSectionTypes } from '@/propTypes';
import {
  ConstituentPropType,
  ConstituentTypes,
} from '../configs/constituentTypes';
import ConstituentCustomFields from './ConstituentCustomFields';
import ConstituentInformationSection from './ConstituentInformationSection';
// eslint-disable-next-line import/no-cycle -- TODO: Fix this the next time the file is edited.
import ConstituentRelationsSection from './ConstituentRelationsSection';
import ConstituentSectionWrapper from './ConstituentSectionWrapper';

const { PERSONAL_INFORMATION, COMPANY_INFORMATION } = ConstituentSectionTypes;

/**
 * This is a component for rendering
 * Info tab content of the Constituent Page
 */
function ConstituentInfoTab({
  constituent,
  constituentType,
  isEditable,
  isNewConstituent,
}) {
  const [showFileUploader, setShowFileUploader] = React.useState(false);
  const { updateConstituent } = useConstituent(constituent?.constituentId);
  const handleUpload = React.useCallback(
    (e) => {
      const attachments = e.map(({ uploadId }) => uploadId);
      updateConstituent({ attachments });
    },
    [updateConstituent],
  );

  return (
    <div className="grid grid-cols-1 gap-6">
      <ConstituentInformationSection
        data={constituent}
        constituentType={constituentType}
        isEditable={isEditable}
        isNewConstituent={isNewConstituent}
        type={
          constituentType === ConstituentType.PERSON
            ? PERSONAL_INFORMATION
            : COMPANY_INFORMATION
        }
      />
      <ConstituentCustomFields constituent={constituent} />
      {!isNewConstituent && (
        <ConstituentRelationsSection
          constituent={constituent}
          isEditable={isEditable}
        />
      )}
      <ConstituentSectionWrapper
        actionLabel={
          !showFileUploader ? translate('ADD_FILES') : translate('HIDE_UPLOAD')
        }
        className="mb-8"
        id="constituent-files-section"
        isEditable
        onActionClick={() => {
          setShowFileUploader(!showFileUploader);
        }}
        title={translate('FILES')}
      >
        <FileUploader
          multiple
          onUploadFinished={handleUpload}
          showDropTarget={showFileUploader}
          value={constituent?.attachments}
        />
      </ConstituentSectionWrapper>
    </div>
  );
}

ConstituentInfoTab.propTypes = {
  constituent: ConstituentPropType.isRequired,
  constituentType: ConstituentTypes.isRequired,
  isEditable: propTypes.bool.isRequired,
  isNewConstituent: propTypes.bool.isRequired,
};

export default ConstituentInfoTab;
